import React, { useContext, useEffect, useRef, useState } from 'react';
import { RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getLabInsightsData } from './LabInsightapi';
import { ChevronRight } from 'lucide-react';

import { Dialog } from 'primereact/dialog';
import { Slider } from 'antd';
import LoginToast from '../../MainLayout/ToastifyLogin';
import { LoginContext } from '../../MainLayout/MainLayout';
import CarouselSlider from '../../Shared/CarouselSlider/CarouselSlider';
import IntroSection from '../../Shared/IntroSection/IntroSection';
import SecondSection from '../../Shared/SecondSection/SecondSection';
import CurebaySolutions from '../../Shared/CurebaySolutions/CurebaySolutions';
import ThirdSection from '../../Shared/ThirdSection/ThirdSection';
import CheckHealthSteps from '../../Shared/CheckHealthSteps/CheckHealthSteps'
import ConcernsSection from '../../Shared/ConcernsSection/ConcernsSection';

import './labinsight.css';




const LabInsightsMain = () => {
  const { openLogin } = useContext(LoginContext);
  const storedData1 = JSON.parse(sessionStorage.getItem('patientData'));
  const userData = storedData1;
  const loginToastRef = useRef(null);

  const [attrs, setAttrs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [uploadedImage, setUploadedImage] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [expandedCard, setExpandedCard] = useState(null);


  const handleOpen = (e) => {
    if (!userData?.patientId) {
      e.preventDefault();
      openLogin();
      return;
    }
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setUploadedImage(null);
    setPdfUrl(null);
  };

  const navigate = useNavigate();

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  // Fetch data from API
  useEffect(() => {
    let isMounted = true;
    getLabInsightsData()
      .then((res) => {
        if (!isMounted) return;
        const entry = res.data?.data?.[0]?.attributes;
        setAttrs(entry || {});
        console.log('API Response:', entry);
      })
      .catch((err) => {
        if (!isMounted) return;
        console.error('Error fetching data:', err);
        setError(err);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) return <div className="p-8 text-center">Loading…</div>;
  if (error) return <div className="p-8 text-center text-red-600">Error loading data.</div>;
  if (!attrs) return <div className="p-8 text-center">No data</div>;

  // Extract data from API response
  const firstcompItem = attrs.first?.[0] || {};
  const heading = firstcompItem.heading || '';
  const subheading = firstcompItem.subheading || '';
  const description = firstcompItem.description || '';
  const image= firstcompItem.imgurl || '';
  const button= firstcompItem.button || '';

   const handleCheckVitals = (e) => {
    if (!userData?.patientId) {
      e.preventDefault();
        openLogin();
    }else{
      navigate("/ask-caresathi?lab_report_analyser=true&popup=true")
    }
  };

 

const handleCardClick = (item) => {
  const subheading = item?.subheading?.toLowerCase() || "";

  // ✅ Add your manual conditions here
  if (subheading === "caresathi") {
    navigate("/caresathi");
  } else if (subheading === "labinsights") {
    navigate("/labinsights");
  } else if (subheading === "skincare") {
    navigate("/skincare");
  } else if (subheading === "oralcare") {
    navigate("/oralcare");
  } else {
    console.warn("No route found for:", subheading);
  }
};

  const firstSectionItems = [
    {
      heading,
      subheading,
      description,
      button,
      onButtonClick:handleCheckVitals,
      image:image,
    
    },
  ];

  const secondcompArr = attrs.second?.[0]?.secsub || [];
  const thirdSection = attrs.third?.[0] || {};
  const fourthSection = attrs.fourth?.[0] || {};
  const fifthSection = attrs.fifth?.[0] || {};
  const sixthSection = attrs.sixth?.[0] || {};
  const sixthSectionItems = sixthSection?.sixthsub || [];
  const seventhSection = attrs.seventh?.[0] || {};
  const seventhSectionItems = seventhSection?.sevensub || [];


console.log('Seventh Section Items:', seventhSectionItems);
  return (
    <>
      <LoginToast ref={loginToastRef} />
      <section>
        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-br from-[#42BA85]/8 to-transparent rounded-full blur-3xl animate-pulse"></div>
          <div
            className="absolute bottom-32 right-16 w-96 h-96 bg-gradient-to-tr from-[#F3F8FF]/10 to-transparent rounded-full blur-3xl animate-pulse"
            style={{ animationDelay: '1s' }}
          ></div>
          <div
            className="absolute top-1/2 left-1/4 w-48 h-48 bg-gradient-to-br from-[#42BA85]/6 to-transparent rounded-full blur-2xl animate-bounce"
            style={{ animationDelay: '2s', animationDuration: '3s' }}
          ></div>
        </div>

        {/* ========================================
            SECTION 1: HERO / HEADER
            ======================================== */}
        {/* <div className="hero-section">
          <h1>{heading}</h1>
          <h2>{subheading}</h2>
          <p>{description}</p>
        </div> */}
        <IntroSection items={firstSectionItems} />

        {/* ========================================
            SECTION 2: SECOND SECTION
            ======================================== */}

            <section className="bg-[#D9F1E7]">

        <SecondSection items={secondcompArr} />
      </section>

        {/* ========================================
            SECTION 3: THIRD SECTION
            ======================================== */}
       {Object.keys(thirdSection).length > 0 && (
  <ThirdSection data={thirdSection} />
)}


        {/* ========================================
            SECTION 4: FOURTH SECTION
            ======================================== */}
        {Object.keys(fourthSection).length > 0 && (
          <CheckHealthSteps data={fourthSection} onButtonClick={handleCheckVitals} />
        )}

        {/* ========================================
            SECTION 5: FIFTH SECTION
            ======================================== */}
        {Object.keys(fifthSection).length > 0 && (
          <ConcernsSection data={fifthSection}  />
        )}

        {/* ========================================
            SECTION 6: SIXTH SECTION
            ======================================== */}
        {Object.keys(sixthSection).length > 0 && (
  <CurebaySolutions
    data={sixthSection}
   onCardClick={handleCardClick}
  />
)}

        {/* ========================================
            SECTION 7: CAROUSEL SLIDER ✅
            ======================================== */}
          {seventhSectionItems.length > 0 && (
  <section className="seventh-section w-full bg-white py-16">
    <div className="max-w-7xl mx-auto px-4">
      {/* Section Header */}
      <div className="text-center mb-12">
        <div className="inline-block mb-4">
          <div className="flex items-center justify-center gap-2 bg-[#F3F8FF] border border-gray-200 px-6 py-3 rounded-full shadow-sm">
            <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center overflow-hidden">
              {seventhSection.iconurl ? (
                <img
                  src={seventhSection.iconurl}
                  alt="icon"
                  className="w-4 h-4 object-contain"
                />
              ) : (
                <span className="text-xs font-bold text-blue-600">✓</span>
              )}
            </div>
            <span className="text-sm font-medium text-#001064">
              {seventhSection.icondesc}
            </span>
          </div>
        </div>

        <h2 className="text-5xl font-bold bg-gradient-to-r from-green-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent">
          {seventhSection.heading}
        </h2>
      </div>

      {/* ✅ Carousel Wrapper */}
      <CarouselSlider
        items={seventhSectionItems}
        visibleSlides={3}
        renderItem={(item) => (
          <div
            key={item.id}
            className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow flex flex-col max-w-sm mx-auto"
          >
            {/* Image Section */}
            {item.imgurl && (
              <div className="relative h-56 overflow-hidden">
                <img
                  src={item.imgurl}
                  alt={item.subheading}
                  className="w-full h-full object-cover"
                />

                {item.iconurl && (
                  <div className="absolute bottom-4 left-7 w-16 h-16 rounded-full bg-gradient-to-r from-green-400 to-cyan-400 flex items-center justify-center shadow-md">
                    <img
                      src={item.iconurl}
                      alt="icon"
                      className="w-8 h-8 object-contain"
                    />
                  </div>
                )}
              </div>
            )}

            {/* Content Section */}
            <div className="p-6 bg-blue-50 flex flex-col flex-grow">
              <h3 className="text-xl font-semibold text-blue-900 mb-3">
                {item.subheading}
              </h3>

              <p className="text-gray-700 text-sm mb-4">
                {item.description}
              </p>

              {/* Show points when expanded */}
              {expandedCard === item.id && item.points && (
                <ul className="space-y-3 mb-6">
                  {item.points.map((point) => (
                    <li key={point.id} className="flex items-start gap-3">
                      <span className="inline-block w-1.5 h-1.5 rounded-full bg-cyan-400 mt-2 flex-shrink-0"></span>
                      <span className="text-sm text-gray-700">
                        {point.points}
                      </span>
                    </li>
                  ))}
                </ul>
              )}

              {/* Read More / Show Less Button */}
              <button
                onClick={() =>
                  setExpandedCard(expandedCard === item.id ? null : item.id)
                }
                className="inline-flex items-center gap-2 text-blue-700 font-semibold text-sm hover:text-cyan-500 transition-colors w-fit mt-auto"
              >
                {expandedCard === item.id ? "Show less" : "Read more"}
                <ChevronRight size={16} className="text-cyan-400" />
              </button>
            </div>
          </div>
        )}
      />
    </div>
  </section>
)}

    
   

      </section>
    </>
  );
};

export default LabInsightsMain;